const TeacherIcon = () => {
  return (
    <svg viewBox="0 0 20.555 22.426">
      <g transform="translate(-63.156 -47.367)">
        <path
          d="M65.959,47.367a2.8,2.8,0,1,0,2.8,2.8A2.8,2.8,0,0,0,65.959,47.367Zm9.329.92a.939.939,0,0,0-.92.949H70.631V51.1h4.515a.842.842,0,0,0,.3,0h6.394v9.343H77.317a.989.989,0,0,0-.113-.015h-.091a.907.907,0,0,0-.1.015h-3.42c-.044-.007-.084-.011-.128-.015a1.048,1.048,0,0,0-.186.015H70.631v1.869h1.606L70.66,68.631a.933.933,0,1,0,1.81.453l1.693-6.767h2.277l1.693,6.767a.933.933,0,1,0,1.81-.453l-1.577-6.314h4.409a.936.936,0,0,0,.934-.934V50.17a.936.936,0,0,0-.934-.934h-6.54a.935.935,0,0,0-.949-.949ZM65.025,54.842a1.868,1.868,0,0,0-1.869,1.869V68.827a.965.965,0,0,0,1.927.062l.409-6.135a.468.468,0,0,1,.934,0l.409,6.139a.965.965,0,0,0,1.927-.062V57.645a.936.936,0,0,1,.934-.934h4.672a.934.934,0,1,0,0-1.869Z"
          transform="translate(0)"
        />
      </g>
    </svg>
  );
};

export default TeacherIcon;
